export default __webpack_public_path__ + "static/Eurowings-Holidays_1_1_de-e47dabe709a81f065ce74bf18c49dacf.png";